import React, { Suspense } from 'react';
import styled from 'styled-components';

import { LoadingIndicator } from '@/components/application/loading-indicator/loading-indicator';
import { HaulerSidebar } from 'src/layouts/HaulerSidebar';
import HaulerRouter from './haulerRouter';

const PageContainer = styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 100% !important;
  max-height: 100% !important;
  position: relative;
  flex-direction: column;
  zindex: 1;

  @media screen and (min-width: 992px) {
    flex-direction: row;
  }
`;

const Content = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export { createRouteMap } from './route-config';

const HaulerSuspenseFallback = () => (
  <div className="wh-ui flex h-full w-full items-center justify-center">
    <LoadingIndicator type="line-simple" size="md" />
  </div>
);

const Hauler = () => {
  return (
    <PageContainer>
      <div>
        <HaulerSidebar />
      </div>
      <Content>
        <Suspense fallback={<HaulerSuspenseFallback />}>
          <HaulerRouter />
        </Suspense>
      </Content>
    </PageContainer>
  );
};

export default Hauler;
